import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  InputGroup,
  Modal,
  Row
} from "react-bootstrap";
import CreateCategory from "./CreateCategory";
import Category from "./Category";
import { BiChevronRight } from "react-icons/bi";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import CategoryLevel from "./CategoryLevel";
import { isFullScreen } from "../../../../utils/general";
import Loading from "./Loading";
import DataTable from "react-data-table-component";
import { Form } from "formik";
import Select from "react-select";

const CategoryList = props => {
  // const [categories, setCategories] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const dispatch = useDispatch();
  const states = useSelector(state => state, shallowEqual);

  const {
    t,
    i18n,
    ticketSubject,
    handleCreateTicketSubject,
    handleUpdateTicketSubject,
    handleDeleteTicketSubject,
    priority,
    nature
  } = props;

  useEffect(() => {
    dispatch({ type: "SET", key: "priorities", payload: priority });
    setPriorities(priority);
  }, [priority]);

  useEffect(() => {
    dispatch({ type: "SET", key: "categories", payload: [] });
    dispatch({ type: "SET", key: "categories", payload: ticketSubject });
  }, [ticketSubject]);
  const parentRef = useRef();

  // console.log('ticketSubject', ticketSubject);
  const [showNewCategoryModal, setShowNewCategoryModal] = useState(false);
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [showNewSubCategoryModal, setShowNewSubCategoryModal] = useState(false);
  const [showCategoryDeleteModal, setShowCategoryDeleteModal] = useState(false);
  const [catToEdit, setCatToEdit] = useState({});
  const [catToDelete, setCatToDelete] = useState({});

  useEffect(() => {
    if (
      typeof parentRef != "undefined" &&
      typeof states?.parentRef == "undefined"
    ) {
      // console.log('parentRef ', parentRef)
      dispatch({ type: "SET", key: "parentRef", payload: parentRef });
    }
  }, [parentRef]);
  const [parentCat, setParentCat] = useState({});
  const columns = [
    {
      name: t("Category Name"),
      selector: row => row.title
    },
    {
      name: t("Priority"),
      center: "true",
      selector: row => t(row.priority?.name)
    },
    {
      name: t("Sub Categories"),
      width: "160px",
      center: "true",
      cell: row => row.items?.length || 0
    },
    {
      name: t("Agents"),
      width: "84px",
      center: "true",
      cell: row => (
        <div title={row.agents?.map(a => a?.label).join("  \n")}>
          {row.agents?.length || 0}
        </div>
      )
    },
    {
      name: "Actions",
      center: "true",
      width: "200px",
      cell: row => (
        <div>
          <Button
            variant={"outline-light"}
            className={"text-success m-2"}
            onClick={() => {
              setParentCat(row);
              setShowNewCategoryModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-plus-circle"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
            </svg>
          </Button>
          <Button
            variant={"outline-light"}
            className={"text-primary m-2"}
            onClick={() => {
              setCatToEdit(() => row);
              setShowEditCategoryModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-square"
              viewBox="0 0 16 16"
            >
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
              <path
                fillRule="evenodd"
                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
              />
            </svg>
          </Button>
          <Button
            variant={"outline-light"}
            className={"text-danger m-2"}
            onClick={() => {
              setCatToDelete(row);
              setShowCategoryDeleteModal(true);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash"
              viewBox="0 0 16 16"
            >
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
            </svg>
          </Button>
        </div>
      )
    }
  ];

  const [selectedCategory, setSelectedCategory] = useState();
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ marginLeft: 50 }}>
        <DataTable
          noHeader
          noTableHead
          columns={columns}
          data={data.items || []}
          expandOnRowClicked
          noDataComponent={
            <div className={"p-1"}>
              <h2>{t("No Sub Category to display")}</h2>
            </div>
          }
          expandableRows
          expandableRowsComponent={<ExpandedComponent />}
          highlightOnHover
          pagination={data.items?.length > 12}
        />
      </div>
    );
  };

  const [newCategory, setNewCategory] = useState({});
  const [updateCategory, setUpdateCategory] = useState({});
  const [updateAgents, setUpdateAgents] = useState([]);
  useEffect(() => {
    if (catToEdit?.id) {
      const slad =
        parseInt(
          (catToEdit.sla?.split(":")[0] - (catToEdit.sla?.split(":")[0] % 24)) /
            24
        ) || 0;
      const slah = parseInt(catToEdit.sla?.split(":")[0] % 24) || 0;
      const slam = parseInt(catToEdit.sla?.split(":")[1]) || 0;
      const slas = parseInt(catToEdit.sla?.split(":")[2]) || 0;
      setUpdateCategory({ ...catToEdit, slad, slah, slam, slas });
      setUpdateAgents(catToEdit.agents || []);
    } else setUpdateCategory({});
  }, [catToEdit]);
  const handleCategoryRowClicked = row => {
    console.log(row);
  };
  const handleSaveNewCategory = () => {
    let slad = newCategory.slad || 0;
    let slah = newCategory.slah || 0;
    let slam = newCategory.slam || 0;
    let slas = newCategory.slas || 0;
    const sla =
      (parseInt(slad) * 24 + parseInt(slah)).toString().padStart(2, "0") +
      ":" +
      slam.toString().padStart(2, "0") +
      ":" +
      slas.toString().padStart(2, "0");
    props.handleCreateTicketSubject(
      newCategory.title,
      newCategory.priority,
      true,
      sla,
      parentCat.id ? [...parentCat.all_parent_id, parentCat.id] : [],
      parentCat?.id || ""
    );
    setCatToEdit({});
    setNewCategory({});
    setParentCat({});
    setShowNewCategoryModal(false);
  };

  const handleUpdateCategory = () => {
    let slad = updateCategory.slad || 0;
    let slah = updateCategory.slah || 0;
    let slam = updateCategory.slam || 0;
    let slas = updateCategory.slas || 0;
    const sla =
      (parseInt(slad) * 24 + parseInt(slah)).toString().padStart(2, "0") +
      ":" +
      slam.toString().padStart(2, "0") +
      ":" +
      slas.toString().padStart(2, "0");
    props.handleUpdateTicketSubject(
      updateCategory.title,
      updateCategory.priority,
      updateCategory.id,
      sla,
      updateCategory.all_parent_id,
      updateCategory.parent_id,
      updateAgents
    );
    setCatToEdit({});
    setNewCategory({});
    setParentCat({});
    setShowEditCategoryModal(false);
  };
  const handleChangeName = e => {
    setNewCategory({ ...newCategory, title: e.target.value });
  };
  const handleChangePriority = e => {
    setNewCategory({
      ...newCategory,
      priority: { name: e.raw.label, label: e.raw.name }
    });
  };
  const handleChangeSLADay = e => {
    setNewCategory({ ...newCategory, slad: e.target.value });
  };
  const handleChangeSLAHour = e => {
    setNewCategory({ ...newCategory, slah: e.target.value });
  };
  const handleChangeSLAMinute = e => {
    setNewCategory({ ...newCategory, slam: e.target.value });
  };
  const handleChangeSLASeconde = e => {
    setNewCategory({ ...newCategory, slas: e.target.value });
  };

  const handleUpdateName = e => {
    setUpdateCategory({ ...updateCategory, title: e.target.value });
  };
  const handleUpdatePriority = e => {
    setUpdateCategory({
      ...updateCategory,
      priority: { name: e.raw.label, label: e.raw.name }
    });
  };
  const handleUpdateAgents = e => {
    setUpdateAgents(e);
  };
  const handleUpdateSLADay = e => {
    setUpdateCategory({ ...updateCategory, slad: e.target.value });
  };
  const handleUpdateSLAHour = e => {
    setUpdateCategory({ ...updateCategory, slah: e.target.value });
  };
  const handleUpdateSLAMinute = e => {
    setUpdateCategory({ ...updateCategory, slam: e.target.value });
  };
  const handleUpdateSLASeconde = e => {
    setUpdateCategory({ ...updateCategory, slas: e.target.value });
  };

  function convertSecondsToHMS(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
      seconds.toString().padStart(2, "0")
    ].join(":");
  }

  return (
    <div
      id={isFullScreen() ? "CategoryListDivFullScreen" : "CategoryListDiv"}
      className="category-list"
      style={{
        overflowX: "auto",
        minHeight: "500px",
        marginBottom: "40px"
        // paddingBottom: "320px"
      }}
      ref={parentRef}
    >
      <div style={{ marginBottom: 10, textAlign: "right" }}>
        <button
          onClick={() => setShowNewCategoryModal(true)}
          className="btn btn-primary button-add-subject"
        >
          <span>+ &nbsp;&nbsp;&nbsp;&nbsp; {t("add new category")}</span>
        </button>
      </div>
      <DataTable
        noHeader
        columns={columns}
        data={states?.categories || []}
        expandOnRowClicked
        expandableRows
        expandableRowsComponent={<ExpandedComponent />}
        highlightOnHover
        pagination
      />

      {/*{states?.categories && states?.categories.length >= 0 ? (*/}
      {/*  <CategoryLevel*/}
      {/*    t={t}*/}
      {/*    i18n={i18n}*/}
      {/*    level={0}*/}
      {/*    parentList={[]}*/}
      {/*    categories={states.categories}*/}
      {/*    priorities={states.priorities}*/}
      {/*    handleCreateTicketSubject={handleCreateTicketSubject}*/}
      {/*    handleUpdateTicketSubject={handleUpdateTicketSubject}*/}
      {/*    handleDeleteTicketSubject={handleDeleteTicketSubject}*/}
      {/*    priority={priority}*/}
      {/*    nature={nature}*/}
      {/*    parentSla="00:00:00"*/}
      {/*    parentPriority={null}*/}
      {/*  />*/}
      {/*) : (*/}
      {/*  <span style={{ textAlign: "center", height: "100%" }}>*/}
      {/*    <Loading />*/}
      {/*  </span>*/}
      {/*)}*/}

      {/*       <CategoryLevel
        t={t}
        i18n={i18n}
        level={0}
        parentList={[]}
        categories={states.categories}
        priorities={states.priorities}
        handleCreateTicketSubject={handleCreateTicketSubject}
        handleUpdateTicketSubject={handleUpdateTicketSubject}
        handleDeleteTicketSubject={handleDeleteTicketSubject}
        priority={priority}
        nature={nature}
        parentSla="00:00:00"
        parentPriority={null}
      /> */}
      <Modal
        show={showNewCategoryModal}
        centered
        backdrop={"static"}
        onHide={() => setShowNewCategoryModal(false)}
      >
        <Modal.Header
          closeButton
          style={{ borderBottomWidth: 0, paddingBottom: 0 }}
        />
        <Modal.Body className={"p-4"} style={{ paddingTop: 0 }}>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>
              {t("settings.tickets_category_content.category_input")}
            </FormLabel>
            <FormControl
              onChange={handleChangeName}
              placeholder={t(
                "settings.tickets_category_content.category_input"
              )}
            />
          </div>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>{t("settings.tickets_priority")}</FormLabel>
            <Select
              className="select-priority"
              onChange={handleChangePriority}
              placeholder={t("settings.auto_priorization.select_priority")}
              options={(states.priorities || []).map(item => ({
                raw: item,
                value: item.label,
                label: t(item.name)
              }))}
            />
          </div>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>
              {t("settings.tickets_category_content.set_sla_for_category")}
            </FormLabel>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-clock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                  </svg>
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                placeholder={t("DD")}
                type={"number"}
                onChange={handleChangeSLADay}
              />
              <FormControl
                placeholder={"HH"}
                type={"number"}
                onChange={handleChangeSLAHour}
              />
              <FormControl
                placeholder={"mm"}
                type={"number"}
                onChange={handleChangeSLAMinute}
              />
              <FormControl
                placeholder={"ss"}
                type={"number"}
                onChange={handleChangeSLASeconde}
              />
            </InputGroup>
          </div>
          <div style={{ marginTop: 30 }}>
            <Button
              onClick={handleSaveNewCategory}
              disabled={!newCategory.priority || !newCategory.title}
              size={"lg"}
              variant={"primary"}
              style={{ width: "100%" }}
            >
              {t("translations.save")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showEditCategoryModal}
        centered
        scrollable={false}
        backdrop={"static"}
        onHide={() => setShowEditCategoryModal(false)}
      >
        <Modal.Header
          closeButton
          style={{ borderBottomWidth: 0, paddingBottom: 0 }}
        />
        <Modal.Body className={"p-4"} style={{ paddingTop: 0 }}>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>
              {t("settings.tickets_category_content.category_input")}
            </FormLabel>
            <FormControl
              defaultValue={catToEdit.title || ""}
              onChange={handleUpdateName}
              placeholder={t(
                "settings.tickets_category_content.category_input"
              )}
            />
          </div>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>{t("settings.tickets_priority")}</FormLabel>
            <Select
              className="select-priority"
              key={updateCategory?.id}
              onChange={handleUpdatePriority}
              defaultValue={{
                raw: updateCategory?.priority,
                value: updateCategory?.priority?.label,
                label: t(updateCategory?.priority?.name)
              }}
              placeholder={t("settings.auto_priorization.select_priority")}
              options={(states.priorities || []).map(item => ({
                raw: item,
                value: item.label,
                label: t(item.name)
              }))}
            />
          </div>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>
              {t("settings.tickets_category_content.set_sla_for_category")}
            </FormLabel>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-clock"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                  </svg>
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                defaultValue={updateCategory.slad}
                placeholder={t("DD")}
                type={"number"}
                onChange={handleUpdateSLADay}
              />
              <FormControl
                defaultValue={updateCategory.slah}
                placeholder={"HH"}
                type={"number"}
                onChange={handleUpdateSLAHour}
              />
              <FormControl
                defaultValue={updateCategory.slam}
                placeholder={"mm"}
                type={"number"}
                onChange={handleUpdateSLAMinute}
              />
              <FormControl
                defaultValue={updateCategory.slas}
                placeholder={"ss"}
                type={"number"}
                onChange={handleUpdateSLASeconde}
              />
            </InputGroup>
          </div>
          <div style={{ marginBottom: 15 }}>
            <FormLabel>{t("assigned_tickets_agents")}</FormLabel>
            <Select
              className="select-priority"
              key={updateCategory?.id}
              onChange={handleUpdateAgents}
              isMulti
              defaultValue={updateAgents}
              placeholder={t("assigned_tickets_agents")}
              options={(states.agentFromPlatform || []).map(item => ({
                value: item.id,
                label:
                  (item.firstName || item.firstname) +
                  " " +
                  (item.lastName || item.lastname || " ")
              }))}
            />
          </div>
          <div style={{ marginTop: 30 }}>
            <Button
              onClick={handleUpdateCategory}
              size={"lg"}
              variant={"primary"}
              style={{ width: "100%" }}
            >
              {t("translations.save")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showNewSubCategoryModal}
        centered
        backdrop={"static"}
        onHide={() => setShowNewSubCategoryModal(false)}
      >
        <Modal.Header closeButton style={{ borderBottomWidth: 0 }} />
        <Modal.Body></Modal.Body>
      </Modal>
      <Modal
        show={showCategoryDeleteModal}
        centered
        backdrop={"static"}
        onHide={() => setShowCategoryDeleteModal(false)}
      >
        <Modal.Header closeButton style={{ borderBottomWidth: 0 }}>
          <Modal.Title>{catToDelete.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ padding: "1px 5px 30px" }}>
            <h3>{t("settings.delete_ticket_subject.message")}</h3>
          </div>
          <div className={""}>
            <Button
              onClick={() => {
                props.handleDeleteTicketSubject(catToDelete);
                setShowCategoryDeleteModal(false);
              }}
              style={{ margin: 5, minWidth: 100 }}
              variant={"danger"}
            >
              {t("yes")}
            </Button>{" "}
            <Button
              style={{ margin: 5, minWidth: 100 }}
              onClick={() => {
                setCatToDelete({});
                setShowCategoryDeleteModal(false);
              }}
              variant={"secondary"}
            >
              {t("no")}
            </Button>
          </div>
          {/*{JSON.stringify(catToDelete)}*/}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CategoryList;
